import * as React from 'react';
import Button from '@mui/material/Button';
import { FetchAPI } from '../util/FetchAPI';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Box from '@mui/material/Box';

export default function NewTeamMemberDialog({refresh}) {
  const [open, setOpen] = React.useState(false);
  const [employeeIdInput, setEmployeeIdInput] = React.useState("");
  const [firstNameInput, setFirstNameInput] = React.useState("");
  const [lastNameInput, setLastNameInput] = React.useState("");

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const submitNewTM = async () => {
    const res = await FetchAPI(`/newTM`, 'POST', {
      staffid: employeeIdInput,
      name: firstNameInput + " " + lastNameInput,
    }, localStorage.getItem("token"));
    
    switch (await res.status) {
      case 200:
        refresh();
        setOpen(false);
        break;
      default:
        console.log(res.data.err);
        break;
    }
  };

  return (
    <div>
      <Box sx={{ display: 'flex', justifyContent: 'center', marginTop: '20px'}}>
        <Button variant="outlined" size="large" onClick={handleClickOpen}>
          Add a team member
        </Button>
      </Box>
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>New Team Member</DialogTitle>
        <DialogContent>
          <TextField
            sx={{ marginTop: '20px' }}
            autoFocus
            id="firstName"
            label="TM #"
            fullWidth
            variant="outlined"
            onChange={(event) => {setEmployeeIdInput(event.target.value)}}
          />
          <TextField
            sx={{ marginTop: '20px' }}
            autoFocus
            id="firstName"
            label="First name"
            fullWidth
            variant="outlined"
            onChange={(event) => {setFirstNameInput(event.target.value)}}
          />
          <TextField
            sx={{ marginTop: '20px' }}
            autoFocus
            id="lastName"
            label="Last name"
            fullWidth
            variant="outlined"
            onChange={(event) => {setLastNameInput(event.target.value)}}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button variant="contained" disableElevation onClick={submitNewTM}>Submit</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}